import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';
import { callAdminApi } from '../../utils/apiCall';

const initialState = {
    isLoading: false,
    error: null,
    wizardData: null,
    createResult: null,
};

const slice = createSlice({
    name: 'superAdminPractices',
    initialState,
    reducers: {
        startLoading(state) {
            state.isLoading = true;
            state.error = null;
        },
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },
        getWizardDataSuccess(state, action) {
            state.isLoading = false;
            state.wizardData = action.payload;
        },
        createPracticeSuccess(state, action) {
            state.isLoading = false;
            state.createResult = action.payload;
        },
        resetCreateResult(state) {
            state.createResult = null;
            state.error = null;
            state.wizardData = null;
        },
    },
});

export const { resetCreateResult } = slice.actions;
export default slice.reducer;

export function getWizardData() {
    return async () => {
        dispatch(slice.actions.startLoading());
        const response = await callAdminApi('/api/v1/management/practices/create/wizard-data/');
        if (response.ok) {
            const {data} = response;
            // Flatten treatments_by_category into a flat treatments array with category field
            const treatments = (data.treatments_by_category || []).flatMap((cat) =>
                (cat.treatments || []).map((t) => ({ ...t, category: cat.category_name }))
            );
            // Map engagement_templates to templates
            const templates = data.engagement_templates || [];
            dispatch(slice.actions.getWizardDataSuccess({
                ...data,
                treatments,
                templates,
            }));
        } else {
            dispatch(slice.actions.hasError(response.data || 'Failed to load wizard data'));
        }
    };
}

export function createPractice(payload) {
    return async () => {
        dispatch(slice.actions.startLoading());
        const response = await callAdminApi('/api/v1/management/practices/create/', 'POST', payload);
        if (response.ok) {
            dispatch(slice.actions.createPracticeSuccess(response.data));
        } else {
            dispatch(slice.actions.hasError(response.data || 'Failed to create practice'));
        }
    };
}
